import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Switch } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  switchBase: {
    " & .MuiSwitch-switchBase": {
      //color: theme.palette.secondary.main,
      color: theme.palette.secondary.main + " !important",
    },
    " & .MuiSwitch-colorSecondary.Mui-checked": {
      color: theme.palette.selected.main + " !important",
    },
    "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-thumb": {
      backgroundColor: theme.palette.selected.main,
    },
    "& .MuiSwitch-track": {
      backgroundColor: "transparent !important",
      border: `2px solid ${theme.palette.secondary.main} !important`,
    },
    "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track": {
      backgroundColor: theme.palette.selected.main + " !important",
      border: `2px solid ${theme.palette.selected.main} !important`,
    },
    "& .MuiSwitch-colorSecondary.Mui-checked.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: theme.palette.selected.main + " !important",
      border: `2px solid ${theme.palette.selected.main} !important`,
    },
    "& .MuiSwitch-colorSecondary.Mui-disabled": {
      opacity: 0.2,
    },
  },
}));

const CustomToggleComponent = ({ checked, onChange, tooltip, disabled }) => {
  const classes = useStyles();

  return (
    <>
      {!!tooltip ? (
        <Tooltip title={tooltip}>
          <Switch
            className={classes.switchBase}
            checked={checked}
            onChange={onChange}
            inputProps={{ "aria-label": "primary checkbox" }}
            disabled={disabled}
          />
        </Tooltip>
      ) : (
        <Switch
          className={classes.switchBase}
          checked={checked}
          onChange={onChange}
          inputProps={{ "aria-label": "primary checkbox" }}
          disabled={disabled}
        />
      )}
    </>
  );
};

CustomToggleComponent.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CustomToggleComponent;
